import { useRouter } from 'next/router'

import useSWR from 'swr'

import { PersonFragment, PersonsDocument } from '@/generated/contentful'

import { client } from '@/lib/contentful/client'

import {
	ResolvedField,
	resolvePath,
	serializeCacheKey,
	useSlug
} from '../../../../lib/contentful/utils'

export function useEntry(): { error: string } | { data: PersonFragment } {
	const slug = useSlug()
	const { locale, isPreview } = useRouter()
	const { data } = useSWR(slug && serializeCacheKey('person', { slug, locale }), () =>
		client({ preview: isPreview }).request(PersonsDocument, {
			where: { slug },
			limit: 1,
			locale,
			preview: isPreview
		})
	)

	if (!slug) return { error: 'Cannot find slug.' }

	const item = data?.personCollection?.items[0]

	if (!item) return { error: `Cannot find resource at ${slug}.` }

	return { data: item }
}

export function useEntryField({ fieldPath }: { fieldPath?: string }): ResolvedField {
	const entry = useEntry()

	if ('error' in entry) return entry

	if (!fieldPath) return { error: 'Field path is not set.' }

	const field = resolvePath(fieldPath, entry.data)

	if (!field) return { error: `Cannot find field at ${fieldPath}. Check the graphql query.` }

	return { data: field }
}
